import { Language } from '@consigli/types';
import i18n from 'i18next';
/**
 * @returns the currently selected language as a Language enum.
 */
export function useCurrentLanguage() {
    const currentLanguage = i18n.language;
    switch (currentLanguage) {
        case 'de':
            return Language.DE;
        case 'en':
        case 'en-GB':
        case 'en-US':
            return Language.EN;
        case 'es':
            return Language.ES;
        case 'fr':
            return Language.FR;
        case 'ja':
            return Language.JA;
        case 'nb':
        case 'no':
        case 'no-NB':
            return Language.NB;
        case 'nn':
        case 'no-NN':
            return Language.NN;
        case 'sv':
            return Language.SV;
        case 'vi':
            return Language.VI;
        case 'ca':
            return Language.CA;
        case 'zh':
            return Language.ZH;
        default:
            return Language.EN;
    }
}
